{
  "version": 1,
  "asset_id": "90368918-1452-454d-a79c-4c1bff39dfec",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/90368918-1452-454d-a79c-4c1bff39dfec/southend-drone-poster-960.jpg",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/90368918-1452-454d-a79c-4c1bff39dfec/southend-drone-poster-960.jpg",
  "original_filename": "southend-drone-poster-960.jpg",
  "size": 101181,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T22:52:34Z"
}
